export enum CharityLookupErrorEnum {
  NONE = 'none', // No error.
  INVALID_FORMAT = 'invalid_format', // Charity number does not match the expected validation regex.
  NOT_FOUND = 'not_found', // Data not found for the charity number.
  API_ERROR = 'api_error', // API call failed.
}

export interface CharityAPIData {
  charity_name: string;
  charity_number: string;
  charity_regulator_link: string;
  registration_date: string;
  phone: string;
  email: string;
  web: string;
  address_line_1: string;
  address_line_2: string;
  address_line_3: string;
  city: string;
  postcode: string;
}

export interface CharityAPIResponse {
  data: CharityAPIData | null;
  error?: string;
}

export interface CharityAddressData {
  charity_name: string;
  address_line_1?: string;
  address_line_2?: string;
  address_line_3?: string;
  city?: string;
  postcode?: string;
}
